import React, {useEffect, useState} from 'react';
import {getFloors} from "../../api/apiClient";
import Form from "react-bootstrap/Form";
import {Col, Row} from "react-bootstrap";

const ComboFcltyDtl = ({
                         propFilterFclty = '',
                         propFilterFcltyDtl = '',
                         propLabel = '층명',
                         propOnChange = null,
                       }) => {

  /* 목록 data */
  const [stList, setList] = useState([]);

  /* 목록 갱신 */
  const updateList = () => {
    getFloors('',
        propFilterFclty,
        '')
        .then((res) => {
              //console.log(res.data.data.list);
              setList(res.data.data.list);
            }
        );
  };

  useEffect(() => {
    updateList();
  }, [propFilterFclty]);

  return (
      /*<Form.Group as={Row} controlId="formBasicSelectMenu">
        <Form.Label column md={3} className={"label text-end "}>
          {propLabel}
        </Form.Label>
        <Col md={9} className={""}>
          <Form.Select
              aria-label="Fclty Select"
              className={"input-select"}
              onChange={propOnChange}
          >
            <option value={""}>전체</option>
            {Array.isArray(stList) && propFilterFclty !== '' ?
                (stList.map((elem, idx) => {
                  let selected = false;
                  if (propFilterFcltyDtl !== '') {
                    selected = propFilterFcltyDtl === elem.cd;
                  }
                  return (
                      <option key={idx} value={elem.cd} selected={selected}>{elem.nm}</option>
                  )
                })) : ''}
          </Form.Select>
        </Col>
      </Form.Group>*/
      <Form.Group as={Row} controlId="formBasicSelectMenu">
        <Form.Label
            className={`col-form-label label text-end`}
            style={{width: "100px"}}
            // column={propLabelRatio ? true : false}
            // sm={propLabelRatio}
        >
          {propLabel}
        </Form.Label>
        <Col>
          <Form.Select
              aria-label="Fclty Select"
              className={"input-select"}
              onChange={propOnChange}
          >
            <option value={""}>전체</option>
            {Array.isArray(stList) && propFilterFclty !== '' ?
                (stList.map((elem, idx) => {
                  let selected = false;
                  if (propFilterFcltyDtl !== '') {
                    selected = propFilterFcltyDtl === elem.cd;
                  }
                  return (
                      <option key={idx} value={elem.cd} selected={selected}>{elem.nm}</option>
                  )
                })) : ''}
          </Form.Select>
        </Col>
      </Form.Group>
  );
};

export default ComboFcltyDtl;